import createPage from '../create-page'
import ArtistListContainer from '../artist-list-container'

export default createPage(ArtistListContainer, 'ARTIST_MENU', true)



// WEBPACK FOOTER //
// ./src/components/artist-menu-page/index.js